import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

@Pipe({
  name: 'loanEndDate'
})
export class LoanEndDatePipe implements PipeTransform {
  transform(endDateStr?: string | null): string {
    const now = dayjs();
    if (!endDateStr) return 'N/A';

    const endDate = dayjs(endDateStr);
    if (!endDate.isValid()) return 'N/A';

    const diffDays = endDate.diff(now, 'day');
    const additionalLine = diffDays > 0 ? `\u000A(in ${diffDays} day${diffDays === 1 ? '' : 's'})` : '';

    return `${endDate.format('MMM DD YYYY')}${additionalLine}`;
  }
}
